import { Injectable } from '@angular/core';
import { SharedDataService } from './shared-data.service';
import { environment } from '../../environments/environment';

import { Observable, of, BehaviorSubject, timer } from 'rxjs';
import { delay, tap, skip, concatMap, concat, map } from 'rxjs/operators';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CpRolesEnum, DEFAULT_POLL_INTERVAL, IPA_POLL_INTERVAL } from 'appRootPath/shared/global-meta-data';


@Injectable({
  providedIn: 'root'
})
export class CpPollerService {
  pollerTime = environment.pollerTime || DEFAULT_POLL_INTERVAL;
  poller$: Observable<any>;
  load$;
  apiCallObservable;
  pollerName = '';
  loaderFlag = false;
  constructor(
    private sharedData: SharedDataService,
    public activeModal: NgbActiveModal
  ) {

  }

  /**
   * UPDATE POLLER
   * @param apiCallObservable the api call observable to poll on; update the poller
   * @param pName the name of the current poller
   */
  updatePollerApi(apiCallObservable, pName) {
    this.apiCallObservable = apiCallObservable;
    this.pollerName = pName;
  }

  /**
   * Create a new poller or update API for an existing poller
   * @param apiCallObservable the API call observable to poll on
   * @param isLoading whether to set the loader or not
   * @param pName the name of the poller obj
   */
  generatePoller(apiCallObservable, isLoading, pName, cb) {
    // if a poller already exists for the component dont create; else create a subject.
    if (this.load$) {
      this.updatePollerApi(apiCallObservable, pName);
    } else {
      this.load$ = new BehaviorSubject('');
      this.pollerName = pName;
      this.apiCallObservable = apiCallObservable;
      // !ToDo Remove when fixed
      this.resetPollInterval();
      const whenToRefresh$ = of('').pipe(
        delay(this.pollerTime), tap(_ => {
          if (isLoading) {
            const modalOpen = document.body.className.match('modal-open');
            const sidebarOpen = document.getElementsByClassName('sidebar-overlay') || [];
            if (!modalOpen && !sidebarOpen.length) {
              // TODO: Remove below line later.
              // this.sharedData.setLoaderState(true);
            }
          }
          if (cb) {
            this.loaderFlag = true;
          }
          this.load$.next('');
        }), skip(1)
      );

      this.poller$ = this.load$.pipe(
        concatMap(_ => this.apiCallObservable.pipe(concat(whenToRefresh$))),
        map(response => response)
      );
    }
  }

  /**
   * Destroy the poller object.
   */
  destroyPoller() {
    this.poller$ = null;
    this.load$ = null;
    this.apiCallObservable = null;
    this.pollerName = null;
    this.loaderFlag = null;
  }

  /**
   * If user is IPA set poll interval as 5 minutes.
   */
  resetPollInterval() {
    if (this.sharedData.getUserDataFromLS().roleType === CpRolesEnum.IPA) {
      this.pollerTime = IPA_POLL_INTERVAL;
    } else {
      this.pollerTime = environment.pollerTime;
    }
  }
}
